var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-opacity-loader"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }